<template>
  <sq-form

      v-if="commonsLoaded&&!loading"
      ref="form"
      :model="bookingData"
      label-width="120px"
      v-loading="pocessing"
      element-loading-text="pocessing..."
      element-loading-spinner="el-icon-loading"
      el
      ement-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <q-card>
      <q-tabs
          v-model="wtab"
          dense
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
      >
        <q-tab
            name="main"
            label="Booking Details"
        ></q-tab>
        <q-tab
            name="lisense"
            label="Driving Lisense"
        />
        <q-tab
            name="DELIVER"
            label="DELIVER"
        />
        <q-tab
            name="RECEIVE"
            label="RECEIVE"
        />
        <q-tab
            name="details"
            label="Details"
        />
        <q-tab
            name="run"
            label="Run"
        />
        <!-- <q-tab name="signature" label="Signature" /> -->
      </q-tabs>

      <q-separator/>

      <q-tab-panels
          v-model="wtab"
          animated
      >
        <q-tab-panel name="main">
          <el-row>
            <el-col
                :xs="24"
                :md="12"
            >
              <s-form-item>
                <q-select
                    filled
                    v-model="bookingData.asset_id"
                    clearable
                    use-input
                    fill-input
                    hide-selected
                    emit-value
                    map-options
                    :option-disable="(item) => item === null ? true : item.id==lastAssetId"
                    input-debounce="0"
                    @filter="filterV"
                    :options="vehicles"
                    option-value="id"
                    option-label="fullName"

                    style="width: 100%"
                ></q-select>
              </s-form-item>
              <el-collapse-transition>
                <s-form-item
                    key="1"
                    v-if="!bookingData.asset_id"
                >please select a vehicle first
                </s-form-item>
                <s-form-item
                    key="2"
                    v-else
                >

                  <el-divider content-position="left" v-if="bookingData.bookingRange"><strong>Days:{{
                      countDateDistance(bookingData.bookingRange.start, bookingData.bookingRange.end)
                    }}</strong></el-divider>
                  <s-av-calendar
                      v-model="bookingData.bookingRange"

                      :key="bookingData.asset_id+clock"
                      :availabilityEndPoint="getRoutes"
                      :availabilityProcessor="checkAvailableVehicles"
                  ></s-av-calendar>
                </s-form-item>
              </el-collapse-transition>
            </el-col>
            <el-col
                :xs="24"
                :md="12"
            >
              <template v-if="!bookingData.parentbk">
                <s-form-item
                    label="Price"
                    :sz="24"
                >
                  <el-row>
                    <el-col
                        :md="8"
                        :xs="24"
                    >
                      <s-select
                          autocompleteModel="Route"
                          v-model="bookingData.details"
                          label-prop="details"
                          value-prop="details"
                          placeholder="Insuranse type"
                          :allow-create="true"
                      ></s-select>
                    </el-col>
                    <el-col
                        :md="10"
                        :xs="20"
                    >
                      <s-number
                          v-model="bookingData.bookedPrice"
                          controls-position="right"
                      ></s-number>

                      <!-- <el-button @click="getPrice()">P</el-button> -->
                    </el-col>
                    <el-col
                        :md="4"
                        :xs="4"
                    >
                      <sf-button
                          style="float:right"
                          material="euro_symbol"
                          type="danger"
                          @click="getPrice()"
                      ></sf-button>
                    </el-col>
                    <el-col :md="24">
                      <el-input
                          v-model="bookingData.note_aboutPayment"
                          placeholder="payment comment"
                      ></el-input>
                    </el-col>
                  </el-row>
                </s-form-item>

                <s-form-item
                    label="Deposit"
                    :sz="24"
                >
                  <el-row>
                    <el-col
                        :md="16"
                        :xs="12"
                    >
                      <s-number
                          v-model="bookingData.bookingFee"
                          controls-position="right"
                      ></s-number>
                    </el-col>
                    <el-col
                        :md="6"
                        :xs="12"
                    >
                      <el-radio-group
                          v-model="bookingData.bookingFee_paymenttype"
                          size="small"
                      >
                        <el-radio-button label="cash">
                          <span class="material-icons">pan_tool</span>
                        </el-radio-button>
                        <el-radio-button label="visa">
                          <span class="material-icons">credit_card</span>
                        </el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                </s-form-item>

                <s-form-item
                    label="Payment"
                    :sz="24"
                >
                  <el-row>
                    <el-col
                        :md="16"
                        :xs="12"
                    >
                      <s-number
                          v-model="bookingData.bookingPayment"
                          controls-position="right"
                      ></s-number>
                    </el-col>
                    <el-col
                        :md="6"
                        :xs="12"
                    >
                      <el-radio-group
                          v-model="bookingData.bookingPayment_paymenttype"
                          size="small"
                      >
                        <el-radio-button label="cash">
                          <span class="material-icons">pan_tool</span>
                        </el-radio-button>
                        <el-radio-button label="visa">
                          <span class="material-icons">credit_card</span>
                        </el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                </s-form-item>
              </template>
              <template v-else>
                <s-form-item>
                  <el-divider content-position="left">Pricing info can be found in the main booking</el-divider>
                  <sf-button
                      type="warning"
                      style="float:right;"
                      @click="routeGo({params:{transferBookingId:bookingData.parentbk.id}})"
                  >Go to Main Booking
                  </sf-button>
                </s-form-item>
              </template>
              <template v-if="bookingData.childs">
                <s-form-item>
                  <el-divider content-position="left">Related bookings</el-divider>
                  <sf-button
                      v-for="childbk in bookingData.childs"
                      :key="childbk.id"
                      style="float:right;"
                      @click="routeGo({params:{transferBookingId:childbk.id}})"
                  >Related Booking ({{ childbk.routeNum }})
                  </sf-button>
                </s-form-item>
              </template>
            </el-col>
          </el-row>
          <el-row>
            <s-form-item
                label="Pick up time"
                :sz="8"
            >
              <el-row>
                <el-col
                    :md="12"
                    :sm="12"
                    :xs="12"
                >
                  <template v-if="bookingData.bookingRange">
                    <div>{{ formatDate(bookingData.bookingRange.start) }}</div>
                    <!--                    <strong>Days:{{ countDateDistance(bookingData.bookingRange.start, bookingData.bookingRange.end) }}</strong>-->
                  </template>
                </el-col>
                <el-col :md="12">
                  <s-time-picker v-model="bookingData.finalPickupTime" @change="++clock"></s-time-picker>
                </el-col>
              </el-row>
            </s-form-item>
            <s-form-item
                label="Pick up location"
                :sz="16"
            >
              <s-remote-select
                  v-model="bookingData.pupAid"
                  class-model="pup"
                  query-prop="q"
                  label-prop="name"
                  captionField="loc_name"
                  @change="bookingData.pupZid?null:bookingData.pupZid=bookingData.pupAid;bookingData.ppid?null:bookingData.ppid=bookingData.pupAid"
                  prefixField="typename"
                  :allow-create="true"
                  editOptionComponentIs="s-pupresolver"
                  :extraQueryParams="userPups"
              ></s-remote-select>
            </s-form-item>
          </el-row>
          <el-row>
            <s-form-item
                label="Drop off time"
                :sz="8"
            >
              <el-row>
                <el-col
                    :md="12"
                    :sm="6"
                    :xs="6"
                >
                  {{ formatDate(bookingData.bookingRange?.end) }}

                </el-col>
                <el-col :md="12">
                  <s-time-picker v-model="bookingData.dropOffTime" @change="++clock"></s-time-picker>
                </el-col>
              </el-row>
            </s-form-item>
            <s-form-item
                label="Drop off location"
                :sz="16"
            >
              <s-remote-select
                  v-model="bookingData.pupZid"
                  class-model="pup"
                  query-prop="q"
                  label-prop="name"
                  :allow-create="true"
                  editOptionComponentIs="s-pupresolver"
                  captionField="loc_name"
                  prefixField="typename"
                  :extraQueryParams="userPups"
              ></s-remote-select>
            </s-form-item>
          </el-row>


          <el-row>
            <s-form-item
                label="Contact Name"
                :sz="8"
            >
              <el-input v-model="bookingData.customer"></el-input>
            </s-form-item>
            <s-form-item
                label="Email"
                :sz="8"
            >
              <el-input v-model="bookingData.note_driver_email"></el-input>
            </s-form-item>
            <s-form-item
                label="Telephone Number (as reference)"
                :sz="8"
                pl
            >
              <el-input v-model="bookingData.reference"></el-input>
            </s-form-item>

            <s-form-item
                label="Place of stay"
                :sz="17"
            >
              <s-remote-select
                  v-model="bookingData.ppid"
                  class-model="pup"
                  query-prop="q"
                  :allow-create="true"
                  editOptionComponentIs="s-pupresolver"
                  label-prop="name"
                  captionField="loc_name"
                  prefixField="typename"
              ></s-remote-select>
            </s-form-item>
            <s-form-item
                label="Room no"
                :sz="7"
            >
              <el-input v-model="bookingData.roomnum"></el-input>
            </s-form-item>
            <s-form-item
                label="Partner"
                :sz="12"
            >
              <s-remote-select
                  :disabled="loggedPartner"
                  v-model="bookingData.coid"
                  class-model="tourcompany"
                  query-prop="q"

                  label-prop="coname"
                  @change="bookingData.repid=null"
              ></s-remote-select>
            </s-form-item>
            <s-form-item
                label="Partner Rep"
                :sz="12"
                class="pl"
            >
              <s-remote-select
                  v-model="bookingData.repid"
                  class-model="rep"
                  query-prop="q"

                  label-prop="name"
                  prefixField="coname"
                  :extra-query-params="{companyId:bookingData.coid}"
              >
                <template slot-scope="{item}">
                  {{ item.name }}
                  <el-tag type="info">{{ item.coname }}</el-tag>
                </template>
              </s-remote-select>
            </s-form-item>

            <el-divider></el-divider>
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 14}"
                placeholder="Some comments......"
                v-model="bookingData.note_generalComments"/>
          </el-row>
        </q-tab-panel>

        <q-tab-panel name="lisense">
          <el-row>
            <!-- <p>{{showUpload}}</p> -->
            <el-col :md="12">
              <a
                  @click="showUpload.a=!showUpload.a"
                  style="display: block;width:100%;text-align:center"
              >
                <img
                    v-if="imgDataUrlDRLA"
                    :src="imgDataUrlDRLA"
                    style="width:100%;display:block;"
                />
                <h4>Front-Lisense</h4>
              </a>

              <my-upload
                  langType="en"
                  field="file"
                  @crop-success="(imgDataUrl, field)=> cropSuccess(imgDataUrl, field, true)"
                  @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail"
                  v-model="showUpload.a"
                  :width="900"
                  :height="500"
                  url="/assets/components/travel/connector.php"
                  :params="{...uploadParams,...prUploadLisense,filename:'DR-FRONT-'+bookingData.id+'.jpg'}"
                  :headers="headers"
                  img-format="jpg"
                  :noRotate="false"
              ></my-upload>
            </el-col>
            <el-col :md="12">
              <a
                  xclass="btn"
                  @click="showUpload.b=!showUpload.b"
                  style="display: block;width:100%;text-align:center"
              >
                <img
                    :src="imgDataUrlDRLB"
                    style="width:100%"
                />
                <h4>Back-Lisense</h4>
              </a>
              <my-upload
                  langType="en"
                  field="file"
                  @crop-success="(imgDataUrl, field)=> cropSuccess(imgDataUrl, field, false)"
                  @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail"
                  v-model="showUpload.b"
                  :width="900"
                  :height="500"
                  url="/assets/components/travel/connector.php"
                  :params="{...uploadParams,...prUploadLisense,filename:'DR-BACK-'+bookingData.id+'.jpg'}"
                  :headers="headers"
                  img-format="jpg"
                  :noRotate="false"
              ></my-upload>
            </el-col>
          </el-row>
        </q-tab-panel>

        <q-tab-panel name="DELIVER">
          <div class="row" v-if="fuels.a">
            <div class="col">{{ formatUnxTime(fuels.a.time) }}</div>
            <q-input class="col" v-model="fuels.a.klmconusmed" label="Klm Now"/>
            <q-input class="col" v-model="fuels.a.load" label="Fuel (8) Now"/>
            <q-input class="col" v-model="fuels.a.comments" label="Condition"/>
          </div>
          <div class="row">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 14}"
                placeholder="Some comments......"
                v-model="bookingData.note_deliverComment"/>
          </div>
          <div v-if="bookingData.note_signature_deliver&&!goSign" class="signature_img">
            <el-popconfirm
                title="Sign again?"
                confirmButtonText="OK"
                cancelButtonText="No, Thanks"
                @confirm="resign"
            >
              <el-button slot="reference">
                <img :src="bookingData.note_signature_deliver"/>
              </el-button>
            </el-popconfirm>
          </div>
          <div v-else style="box-shadow: 0px 0px 3px darkgreen;background-color: #8db8e8;margin: 10px">
            <VueSignaturePad
                width="100%"
                height="300px"
                ref="signaturePad"
                :options="{  onEnd:e=>saveSignature('deliver') }"
            />
            <el-button
                @click="$refs.signaturePad.clearSignature()"
                type="warning"
            >Clear
            </el-button>
          </div>
          <el-upload
              class="upload-demo"
              drag
              :data="prUploadCar"
              :before-upload="beforeUpload"
              action="/assets/components/travel/connector.php"
              :file-list="carPics.deliver?carPics.deliver:[]"
              list-type="picture"
              :on-success="fileUploadSuccess"
              :on-error="fileUploadError"
              :on-remove="removeFile"
              multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              πεταξε το αρχειο εδώ
              <em>ή κανε click εδω για να επισυναψεις αρχειο</em>
            </div>
          </el-upload>

          <div
              label="Fuel Start Level"
              :sz="24"
          >
            <el-input-number
                v-model="bookingData.note_fuelStartLevel"
                :min="1"
                :max="10"
            ></el-input-number>
          </div>
        </q-tab-panel>
        <q-tab-panel name="RECEIVE">
          <div class="row" v-if="fuels.z">
            <div class="col">{{ formatUnxTime(fuels.z.time) }}</div>
            <q-input class="col" v-model="fuels.z.klmconusmed" label="Klm Now"/>
            <q-input class="col" v-model="fuels.z.load" label="Fuel (8) Now"/>
            <q-input class="col" v-model="fuels.z.comments" label="Condition"/>
          </div>
          <div class="row">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 14}"
                placeholder="Some comments......"
                v-model="bookingData.note_receiveComment"/>
          </div>
          <div v-if="bookingData.note_signature_receive&&!goSign" class="signature_img">
            <el-popconfirm
                title="Are you sure to delete this?"
                confirmButtonText="OK"
                cancelButtonText="No, Thanks"
                @onConfirm="goSign=true"
            >
              <el-button slot="reference">
                <img :src="bookingData.note_signature_receive"/>
              </el-button>
            </el-popconfirm>
          </div>
          <div v-else style="box-shadow: 0px 0px 3px darkgreen;background-color: #8db8e8;margin: 10px">
            <h4>Please Sign here</h4>
            <VueSignaturePad
                width="100%"
                height="300px"
                ref="signaturePad"
                :options="{  onEnd:e=>saveSignature('receive') }"
            />
            <el-button
                @click="$refs.signaturePad.clearSignature()"
                type="warning"
            >Clear
            </el-button>
          </div>
          <el-upload
              class="upload-demo"
              drag
              :before-upload="beforeUpload"
              :data="prUploadCar"
              action="/assets/components/travel/connector.php"
              :file-list="carPics.receive?carPics.receive:[]"
              list-type="picture"
              :on-remove="removeFile"
              :on-success="fileUploadSuccess"
              :on-error="fileUploadError"
              multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              πεταξε το αρχειο εδώ
              <em>ή κανε click εδω για να επισυναψεις αρχειο</em>
            </div>
          </el-upload>

          <div
              label="Fuel return Level"
              :sz="24"
          >
            <el-input-number
                v-model="bookingData.note_fuelReturnLevel"
                :min="1"
                :max="10"
            ></el-input-number>
          </div>
        </q-tab-panel>
        <q-tab-panel name="details">
          <s-form>
            <h4>Primary Driver</h4>

            <s-form-item
                label="License Name"
                :sz="12"
            >
              <el-input v-model="bookingData.note_drivingLicenseName"></el-input>
            </s-form-item>

            <s-form-item
                label="Home Address"
                :sz="12"
            >
              <el-input v-model="bookingData.note_homeAddress"></el-input>
            </s-form-item>

            <s-form-item
                label="Passport No"
                :sz="6"
            >
              <el-input v-model="bookingData.note_passportNum"></el-input>
            </s-form-item>

            <s-form-item
                label="Passport Expire"
                :sz="6"
            >
              <el-input v-model="bookingData.note_passportExpire"></el-input>
            </s-form-item>

            <s-form-item
                label="Origin"
                :sz="12"
            >
              <el-input v-model="bookingData.note_origin"></el-input>
            </s-form-item>

            <s-form-item
                label="Driving License No"
                :sz="12"
            >
              <el-input v-model="bookingData.note_drivingLicenseNum"></el-input>
            </s-form-item>

            <s-form-item
                label="Country Of Regist"
                :sz="12"
            >
              <el-input v-model="bookingData.note_countryOfRegist"></el-input>
            </s-form-item>

            <s-form-item
                label="Date of Issue "
                :sz="24"
            >
              <el-input v-model="bookingData.note_issueDate"></el-input>
            </s-form-item>

            <s-form-item
                label="Birth Date"
                :sz="24"
            >
              <el-input v-model="bookingData.note_birthDate"></el-input>
            </s-form-item>

            <h4>Additional Driver</h4>

            <s-form-item
                label="Full Name"
                :sz="18"
            >
              <el-input v-model="bookingData.note_additionalDriver"></el-input>
            </s-form-item>
            <s-form-item
                label="Birth Date"
                :sz="6"
            >
              <el-input v-model="bookingData.note_additionalDriverBirthDate"></el-input>
            </s-form-item>
            <s-form-item
                label="Driving License No"
                :sz="8"
            >
              <el-input v-model="bookingData.note_additionalDriverLicenseNum"></el-input>
            </s-form-item>
            <s-form-item
                label="Date of Issue "
                :sz="8"
            >
              <el-input v-model="bookingData.note_additionalDriverIssueDate"></el-input>
            </s-form-item>
            <s-form-item
                label="Country Of Regist"
                :sz="8"
            >
              <el-input v-model="bookingData.note_additionalDriverCountryOfRegist"></el-input>
            </s-form-item>
          </s-form>

        </q-tab-panel>
        <q-tab-panel name="run">
          <div>

            <vehicle-fuels :display-vehicle-run="true"
                           v-if="bookingData.asset_id&&bookingData.routeNum"
                           :specific-asset-id="bookingData.asset_id"
                           :for-route-id="bookingData.routeNum"></vehicle-fuels>
          </div>

        </q-tab-panel>
        <!-- <q-tab-panel name="signature">
          <div v-if="bookingData.note_signature&&!goSign">
            <el-popconfirm
              title="Are you sure to delete this?"
              confirmButtonText="OK"
              cancelButtonText="No, Thanks"
              @onConfirm="goSign=true"
            >
              <el-button slot="reference">
                <img :src="bookingData.note_signature" />
              </el-button>
            </el-popconfirm>
          </div>
          <div v-else>
            <VueSignaturePad
              width="100%"
              height="500px"
              ref="signaturePad"
              :options="{  onEnd:save }"
            />
            <el-button @click="$refs.signaturePad.clearSignature()" type="warning">Clear</el-button>
          </div>
        </q-tab-panel>-->
      </q-tab-panels>
    </q-card>

    <!-- <s-form-actions v-if="bookingData.tripType=='EXCRS'">
      <sf-button
        @click="$emit('done', null)"
        style="float: right;"
        type="text"
        title="just go back to the route list"
      >
        <i class="material-icons">clear</i>
      </sf-button>
    
    </s-form-actions>-->
    <s-form-actions slot="actions" :responsive="true">
      <sf-button :slot="isWindowSize('sm',true)?'left':null"
                 @click="$emit('done',bookingData);routeGo({name:'timelineForProducts',params:{transferBookingId:null}, query:{_asset: null}});"
                 type="text"
      >
        <i class="material-icons">clear</i>
      </sf-button>
      <span style="width: 10px" slot="left"></span>
      <template v-if="bookingData&&bookingData.id">

        <sf-button
            id="unlockBtn"
            v-if="bookingData.locked"
            @click="bookingData.locked=false;saveRoute(true)"
            style="float: right;"
            type="warning"
            slot="left"
        >
          <i class="material-icons">refresh</i>
        </sf-button>

        <template v-else>
          <sf-button
              style="float: left;"
              type="danger"
              slot="left"
              confirm="are you sure?"
              v-if="!bookingData.locked"
              @click="removeRoute()"
          >
            <i class="material-icons">delete</i>
          </sf-button>
          <sf-button
              title="This action will UN-cancel the rental"
              confirm="This action will UN-cancel the rental. Are you sure?"
              type="warning"
              v-if="bookingData.execStatus=='canceled'"
              style="float: left;"
              slot="left"
              @click="bookingData.execStatus='normal';saveRoute(true)"
          >
            <span class="material-icons">store</span>
            <i class="material-icons">thumb_up</i>
          </sf-button>
          <sf-button
              v-else
              title="The rental has been CANCELED by YOU"
              confirm="This action will CANCEL the rental because. YOUR COMPANY'S DEICISION. Are you sure?"
              type="danger"
              style="float: left;"
              slot="left"
              @click="bookingData.execStatus='canceled';saveRoute(true)"
          >
            <span class="material-icons">store</span>
            <i class="material-icons">block</i>
          </sf-button>
          <sf-button
              title="This action will UN-cancel the rental"
              confirm="This action will UN-cancel the rental. Are you sure?"
              type="warning"
              v-if="bookingData.status=='canceled'"
              style="float: left;"
              slot="left"
              @click="bookingData.status='normal';saveRoute(true)"
          >
            <i class="material-icons">thumb_up</i>
          </sf-button>
          <sf-button
              v-else
              title="The rental has been CANCELED by CLIENT"
              confirm="This action will CANCEL the rental. CLIENT DEICISION. Are you sure?"
              type="danger"
              style="float: left;"
              slot="left"
              @click="bookingData.status='canceled';saveRoute(true)"
          >
            <i class="material-icons">block</i>
          </sf-button>
          <sf-button
              type="warning"
              style="float: left;"
              slot="left"
              @click="bookingData.locked=true;saveRoute(true)"
          >
            <i class="material-icons">vpn_key</i>
          </sf-button>
        </template>
        <sf-button
            type="success"
            plain
            slot="middle"
            @click="goPdf('voucher-printer.html',{bkid:bookingData.id});"
        >
          <el-tag type="primary" :title="bookingData.routeNum">{{ bookingData.id }}</el-tag>
          <i class="material-icons">print</i>
        </sf-button>
        <!-- <s-invoice-issuer v-model="bookingData" slot="middle"></s-invoice-issuer> -->
        <sf-button
            type="warning"
            @click="routeGo({
            params: {transferBookingId: 'copy'},
            query: {copy_id: bookingData.id},
          });"
            slot="left"
            title="Copy"
            material="file_copy"
        >
        </sf-button>
        <!--        <sf-button-->
        <!--            type="warning"-->
        <!--            @click="brakeBooking()"-->
        <!--            slot="middle"-->
        <!--        >Change Vehicle-->
        <!--        </sf-button>-->
      </template>
      <el-tag v-else type="danger" slot="middle">NEW</el-tag>

      <sf-button
          type="primary"
          @click="saveRoute(true)"
      >
        <i class="material-icons">done</i>
      </sf-button>
    </s-form-actions>
    <q-dialog
        v-model="confirmSave"
        persistent
    >
      <q-card>
        <q-card-section class="row items-center">
          <span
              class="material-icons"
              color="orange"
          >info</span>
          <span class="q-ml-sm">For uploading images you need to save this booking first</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
              flat
              label="Cancel"
              color="warning"
              @click="wtab='main'"
              v-close-popup
          />
          <q-btn
              flat
              label="Save it"
              color="primary"
              @click="saveRoute(true)"
              v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </sq-form>
</template>

<script>
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import * as moment from "moment";
import myUpload from "vue-image-crop-upload";
import VehicleFuels from "../VEHICLES/VehicleFuels.vue";
import {removeObject} from "../../../api/resource";
import imageCompression from 'browser-image-compression';

let allVehicles = []
export default {
  mixins: [commons],
  components: {
    VehicleFuels,
    "my-upload": myUpload,
  },
  props: {
    initialTime: {
      // type: Date,
      default: null,
    },
    selectedAssetId: {
      type: Number,
      default: null,
    },
  },
  async mounted() {
    this.resetFuels()

    if (this.$route.query.selected_asset)
      this.$set(
          this.bookingData,
          "asset_id",
          parseInt(this.$route.query.selected_asset)
      );
    await this.prepareLoggedData();

    // _log_("huppy ", user);
    this.loading = false;
  },

  data() {
    const today = new Date()
    return {
      clock: 0,
      confirmSave: false,
      wtab: "main",
      showUpload: {a: false, b: false},
      imgDataUrlDRLB: null,
      imgDataUrlDRLA: null,
      headers: null,
      goSign: true,
      // scheduleTripRequest: { with: "TripService" },
      routeFlight: {},
      workingtab: "mails",
      splitterModel: 20,
      bookingSize: 0,
      loading: true,
      show: false,
      carPics: {receive: null, deliver: null},
      lisensePics: null,
      loggedPartner: false,
      lastAssetId: null, //need that when cloning for extyending rental
      errors: {},
      pocessing: false,
      bookingData: {finalPickupTime: "09:00", dropOffTime: "09:00", bookingRange: {start: today, end: today}},
      planedTime: null,
      selectedFlightId: null,
      arvFlightDate: null,
      depFlightDate: null,
      vehicleCapacities: null,
      vehicles: null,
      selectedVehicle: null,
      userPups: null,
      fuels: null,
      uploadParams: {
        HTTP_MODAUTH: window.Travel.auth,
        ctx: "web",
        do: "upload",
        action: "gears/archive",
      },
    };
  },
  methods: {
    resetFuels() {
      this.fuels = {
        a: {load: null, time: this.unxnow(), comments: null, klmconusmed: null, status: 'checkin'},
        z: {load: null, time: this.unxnow() + 10, comments: null, klmconusmed: null, status: 'checkout'}
      }
    },
    async beforeUpload(file) {
      // Compression options
      const options = {
        maxSizeMB: 0.5, // Maximum size in MB
        maxWidthOrHeight: 1524, // Maximum width or height in pixels
        useWebWorker: true
      };

      try {
        // Compress the image file
        const compressedFile = await imageCompression(file, options);

        // Replace the original file with the compressed file
        return compressedFile;
      } catch (error) {
        console.error("Image compression error:", error);
        return false; // Prevent upload if compression fails
      }
    },
    async prepareFuels() {

      if (this.bookingData.id && this.bookingData.asset_id) {

        const Q = {

          routename: this.bookingData.routeNum,
          selectedVehicle: this.bookingData.asset_id,
          sort: 'time',
          dir: 'asc',
          view: 'rental'
        };
        const data = await api.getModxList('fuels', Q)
        if (data) {

          if (data?.length) {
            this.fuels.a = this.findInArray(data, {status: 'checkin'}) || this.fuels.a
            this.fuels.z = this.findInArray(data, {status: 'checkout'}) || this.fuels.z

          }
          _log_("prepareFuels....", data, this.fuels);
        }
      }


    },
    fileUploadSuccess(response, file, fileList) {

      this.$notify({
        title: 'Success',
        message: 'Τα καταφέραμε το αρχείο είναι στον server',
        type: 'success'
      });
    },
    fileUploadError(err, file, fileList) {
      _log_("fileUploadError....", err, file, fileList);
      this.$notify.error({
        title: 'Error',
        message: 'Κάτι προέκυψε δεν νομίζω οτι το αρχείο καταχωρήθηκε'
      });
    },
    removeFile(file, fileList) {
      _log_("removeFile....", file, fileList);
      api.removeObject('attachments', file)
    },
    resign() {
      // this.$refs.signaturePad.clearSignature();
      this.bookingData.note_signature_deliver = null;
      this.goSign = true
      _log_("resign....", this.bookingData);
    },
    filterV(val, update) {
      if (val === '') {
        update(() => {
          this.vehicles = allVehicles

          // with Quasar v1.7.4+
          // here you have access to "ref" which
          // is the Vue reference of the QSelect
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.vehicles = allVehicles.filter(v => v.fullName.toLowerCase().indexOf(needle) > -1)
      })
    },

    setRange(start, size) {
      const dmm = 60 * 60000 * 25;
      _log_("-----cCAL--- setRange success --------", start, size);
      if (!this.bookingData.bookingRange) this.bookingData.bookingRange = {};
      if (!start && this.$route.query.initialTime) {
        size == 1;
        const dt = new Date(parseInt(this.$route.query.initialTime)),
            hh = parseInt(dt.getHours());
        this.$set(this.bookingData.bookingRange, "start", dt);
        this.$set(this.bookingData.bookingRange, "end", new Date(dt));
        if (hh > 14) start = "evening";
        else start = "morning";
      } else if (!this.bookingData.bookingRange?.start) {
        this.$set(this.bookingData.bookingRange, "start", new Date());
        this.$set(this.bookingData.bookingRange, "end", new Date());
        if (!size) size = 0.5;
      }

      const q = this.strTimeToInt(this.bookingData.finalPickupTime);
      if (start == "nail" && this.bookingData.finalPickupTime)
        if (this.strTimeToInt(this.bookingData.finalPickupTime) < 900)
          start = "morning";
        else start = "evening";
      if (start == "evening") {
        this.bookingData.finalPickupTime = "15:00";
        this.bookingData.bookingRange.start.setHours(15);
        this.bookingData.bookingRange.start.setMinutes(0);
      } else {
        this.bookingData.finalPickupTime = "09:00";
        this.bookingData.bookingRange.start.setHours(9);
        this.bookingData.bookingRange.start.setMinutes(0);
      }
      // this.bookingData.bookingRange.start = new Date(
      //   this.bookingData.bookingRange.start
      // );
      // this.bookingData.bookingRange.end = new Date(this.bookingData.bookingRange.end);
      if (size) {
        if (this.bookingData.finalPickupTime) {
          if (size == 0.5 || size == 1.5) {
            if (this.bookingData.finalPickupTime == "09:00")
              this.bookingData.dropOffTime = "15:00";
            else this.bookingData.dropOffTime = "21:00";
          }
          // if (size == 1) {
          //   this.bookingData.dropOffTime =
          //       this.bookingData.finalPickupTime// == "09:00" ? "21:00" : "15:00";
          //   if (this.bookingData.finalPickupTime == "15:00")
          //     this.bookingData.bookingRange.end = new Date(
          //         this.bookingData.bookingRange.start.getTime() + dmm
          //     );
          //   // else
          //   //   this.bookingData.bookingRange.end = this.bookingData.bookingRange.start;
          // }
          if (size == 0.5) {
            this.bookingData.bookingRange.end = new Date(
                this.bookingData.bookingRange.start
            );
          } else if (size >= 1) {
            this.bookingData.bookingRange.end = new Date(
                this.bookingData.bookingRange.start.getTime() + dmm
            );
          }
          // if (this.bookingData.finalPickupTime == "09:00") {
          //   this.bookingData.bookingRange.end.setHours(9);
          //   this.bookingData.bookingRange.end.setMinutes(0);
          // } else {
          //   this.bookingData.bookingRange.end.setHours(15);
          //   this.bookingData.bookingRange.end.setMinutes(0);
          // }
        }
      }
      this.$set(
          this.bookingData,
          "bookingRange",
          {start: this.bookingData.bookingRange?.start, end: this.bookingData.bookingRange?.end}
      );
      // this.$set(
      //     this.bookingData.bookingRange,
      //     "end",
      //     this.bookingData.bookingRange.end
      // );
      // this.$set(
      //     this.bookingData.bookingRange,
      //     "start",
      //     this.bookingData.bookingRange.start
      // );
    },
    async prepareLoggedData() {
      const user = await this.getLoggedUser();

      if (user.relRep) {
        this.$set(this.bookingData, "coid", user.relRep.companyId);
        this.$set(this.bookingData, "repid", user.relRep.id);
        if (user.relRep.workingPlaces) {
          this.userPups = {id_priority: user.relRep.workingPlaces};
          const arr = user.relRep.workingPlaces.split(",");
          this.$set(this.bookingData, "pupAid", arr[0]);
          this.$set(this.bookingData, "pupZid", arr[0]);
        }
        this.loggedPartner = true;
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field, isFront) {
      if (isFront) this.imgDataUrlDRLA = imgDataUrl;
      else this.imgDataUrlDRLB = imgDataUrl;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      _log_("-------- upload success --------");
      _log_(jsonData);
      _log_("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      _log_("-------- upload fail --------");
      _log_(status);
      _log_("field: " + field);
    },

    async getRoutes(range) {
      _log_("--checkAvailableVehicles------ GET ROUTES --------", range);
      return await api.getModxList("vue_route", {
        limit: 0,
        daterange: range,

        for: "rental",
        vehicleGroup: this.$route.params.vehicleGroup,
        with: "Vehicle",
        incluedCanceled: false,
        // asset_id: this.workingProduct.id,
      });
    },
    processDateRange() {
      let timeA = new Date(this.bookingData.bookingRange.start),
          timeZ = new Date(this.bookingData.bookingRange.end),
          timePartsA = this.bookingData.finalPickupTime.split(":"),
          timePartsZ = this.bookingData.dropOffTime.split(":");
      _log_("-------- GET ROUTES --------", timePartsA, timePartsZ);
      // d.setHours
      timeA.setMinutes(parseInt(timePartsA[1]));
      timeA.setHours(parseInt(timePartsA[0]));
      timeZ.setMinutes(parseInt(timePartsZ[1]));
      timeZ.setHours(parseInt(timePartsZ[0]));
      _log_(
          "-------- GET TIMES -----0---",
          Math.floor(timeA.getTime() / 1000),
          Math.floor(timeZ.getTime() / 1000)
      );
      if (this.bookingData.bookingRange && this.bookingData.bookingRange.start) {
        this.$set(this.bookingData, "in", Math.floor(timeA.getTime() / 1000));
        this.$set(this.bookingData, "out", Math.floor(timeZ.getTime() / 1000));
      }
    },
    async updateVehicleDrafts() {
      try {
        if (!this.fuels.a?.time) this.fuels.a.time = this.unxnow()
        if (!this.fuels.z?.time) this.fuels.z.time = this.unxnow() + 10
        this.fuels.a.status = 'checkin'
        this.fuels.z.status = 'checkout'
        this.fuels.a.route_id = this.bookingData.routeNum
        this.fuels.a.asset_id = this.bookingData.asset_id
        if (this.fuels.a.id || this.fuels.a.klmconusmed || this.fuels.a.load || this.fuels.a.comments) {
          _log_("dataF saving fuels..A.", this.fuels.a);
          this.fuels.a = await api.updateProcessor("fuels/updatevehicle", this.fuels.a);
        }
        this.fuels.z.route_id = this.bookingData.routeNum
        this.fuels.z.asset_id = this.bookingData.asset_id
        if (this.fuels.z.id || this.fuels.z.klmconusmed || this.fuels.z.load || this.fuels.z.comments) {

          _log_("dataF saving fuels..X.", this.fuels.z);
          this.fuels.z = await api.updateProcessor("fuels/updatevehicle", this.fuels.z);
        }

      } catch (error) {
        _log_("error saving fuels...", error, error.message);
        // this.$notify.error({
        //   title: "!!!Δεν αποθυκεύτηκε η εγγραφή",
        //   message: error.message.message
        // });
      }
    },
    async saveRoute(stay, andNew, copyRental) {
      _log_(
          "-------- saveRoute--------",
          this.bookingData
      );
      if (!this.bookingData.pupAid) {
        this.$notify.error('Please set a pickup location first')
        return
      }
      this.pocessing = true;
      if (!this.bookingData.adults) this.bookingData.adults = 1; //need that because the route will not show
      if (!this.bookingData.status) this.bookingData.status = "normal";
      if (!this.bookingData.execStatus) this.bookingData.execStatus = "normal";
      this.bookingData.destination = "RENTAL";

      // this.bookingData.asset_id = this.selectedVehicle.id;
      this.bookingData.type = "CAR-RENTAL";
      this.processDateRange();
      // _log_(
      //     "-------- GET TIMES --------",
      //     this.bookingData
      // );
      const dataBack = await api.updateProcessor(
          "vue_booking/updaterental",
          this.bookingData
      );
      if (this.$route.params.transferBookingId == 'copy' || this.$route.params.transferBookingId == 'new') {
        //that means copy was saved
        this.routeGo(
            {
              params: {transferBookingId: dataBack.id},
            },
            true
        );
        this.pocessing = false;
        return
      }
      this.bookingData.id = dataBack.id;
      this.bookingData.routeNum = dataBack.routeNum;

      await this.updateVehicleDrafts();
      this.pocessing = false;

      if (copyRental) {
        const copyId = this.bookingData.id * 1;
        this.wtab = 'main'
        this.resetFuels()
        if (copyRental != 'full') {
          this.lastAssetId = this.bookingData.asset_id + "";
          this.bookingData.asset_id = null;
          // this.bookingData.id = null;
          // this.bookingData.copy = dataBack.id;
          this.$set(this.bookingData, "bookingRange", {
            start: this.bookingData.bookingRange.end,
            end: this.bookingData.bookingRange.end,
          });

          this.bookingData.routeSeq = this.bookingData.routeSeq
              ? this.bookingData.routeSeq
              : "parent:" + this.bookingData.routeNum;
          this.$set(this.bookingData, "routeNum", null);
          this.$set(this.bookingData, "id", null);
          this.$set(this.bookingData, "bookedPrice", null);
          this.$set(this.bookingData, "bookingFee", null);
          this.$set(this.bookingData, "bookingPayment", null);

          if (!this.bookingData.coid) await this.prepareLoggedData();
          const dataBackCopy = await api.updateProcessor(
              "vue_booking/updaterental",
              {...this.bookingData, copy: dataBack.id}
          );
          this.$set(this.bookingData, "routeNum", dataBackCopy.routeNum);
          this.$set(this.bookingData, "id", dataBackCopy.id);
//this.bookingData.id

          this.routeGo({
            params: {transferBookingId: copyId},
          });
          this.pocessing = false;
          return;
        }
//         else {
//           // _log_('Μεγιά')
//           // let cpData = {...this.bookingData}
//           // cpData.id = null
//           //
//           // cpData.routeNum = null
//           // _log_('Μεγιά', cpData)
//           // cpData = await api.updateProcessor(
//           //     "vue_booking/updaterental",
//           //     cpData
//           // );
//           // this.$set(this.bookingData, "routeNum", cpData.routeNum);
//           // this.$set(this.bookingData, "id", cpData.id);
// //this.bookingData.id
// //           this.$set(this.bookingData, "routeNum", null);
// //           this.$set(this.bookingData, "id", null);
// //           _log_("copy....", copyId);
// //           this.routeGo({
// //             params: {transferBookingId: 'copy'},
// //             query: {copy_id: copyId},
// //           });
// //           this.$notify({
// //             title: 'ΜεΓειά',
// //             message: 'Έχουμε αντίγραφο',
// //             type: 'success',
// //
// //           });
//           this.routeGo({
//             params: {transferBookingId: 'copy'},
//             query: {copy_id: copyId},
//           });
//           this.pocessing = false;
//           return;
//         }
      }
      // return;

      if (andNew) {
        this.wtab = 'main'
        const rPrts = this.$route.path.split("/transferBooking/");
        this.routeGo({path: rPrts[0] + "/transferBooking/new"});
      } else if (!stay) {
        this.$emit("done", this.bookingData);
        this.routeGo({
          name: "timelineForProducts",
          params: {transferBookingId: null},
          query: {initialTime: null, selected_asset: null, rentState: null},
        });
      } else if (this.$route.params.transferBookingId == "new" || this.$route.params.transferBookingId == "copy")
        this.routeGo(
            {
              params: {transferBookingId: copyId},
            },
            true
        );

      this.pocessing = false;
    },
    async removeRoute(andNew) {
      this.pocessing = true;
      try {
        this.bookingData = await api.removeObject("vue_route", {
          id: this.bookingData.routeNum,
        });
      } catch (error) {
        _log_("error", error);
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.bookingData);
      this.$emit("done", this.bookingData);
      this.routeGo({
        name: "timelineForProducts",
        params: {transferBookingId: null},
        query: {initialTime: null, selected_asset: null, rentState: null},
      });
      this.pocessing = false;
    },
    async loadImages(type) {
      if (!this.bookingData || !this.bookingData.id) return;
      if (type == "VEHICLE-DELIVER") {
        // _log_("reading pices...", dt, this.bookingData.bookingRange);
        const dataVD = await api.fetchProcessor("gears/archive", {
          ...this.uploadParams,
          refNum: this.bookingData.id,
          do: "list-attatchments",
          context: "VEHICLE-DELIVER",
        });
        this.carPics.deliver = dataVD.data.object;
      } else {
        const dataRV = await api.fetchProcessor("gears/archive", {
          ...this.uploadParams,
          refNum: this.bookingData.id,
          do: "list-attatchments",
          context: "VEHICLE-RECEIVE",
        });
        this.carPics.receive = dataRV.data.object;
      }
    },
    async loadRoute(bkid, dontLoadFuel) {
      this.loading = true;
      const vm = this;
      if (bkid)
        if (bkid == "copy") {
          this.bookingData.id = null
          this.bookingData.routeNum = null
          return
        } else if (bkid == "new") this.bookingData = {};
        else {
          this.bookingData = await api.fetchObject("vue_booking", {
            id: bkid,
            format: "rental",
          });
          if (!dontLoadFuel) await this.prepareFuels()
        }

      const datap = await api.fetchProcessor("gears/archive", {
        ...this.uploadParams,
        refNum: this.bookingData.id,
        do: "list-attatchments",
        context: "DR-LISENSE",
      });

      this.lisensePics = datap.data.object;
      if (datap.data.object)
        datap.data.object.forEach((p) => {
          if (p.url.indexOf("FRONT") >= 0) vm.imgDataUrlDRLA = p.url;
          if (p.url.indexOf("BACK") >= 0) vm.imgDataUrlDRLB = p.url;
        });

      this.loading = false;
      this.$nextTick(() => {
        if (this.bookingData && this.bookingData.note_signature) this.goSign = false;
        this.$set(this.bookingData, "bookingRange", {
          start: new Date(this.bookingData.in * 1000),
          end: new Date(this.bookingData.out * 1000),
        });
        if (!this.bookingData.note_fuelStartLevel)
          this.$set(this.bookingData, "note_fuelStartLevel", 10);
        if (!this.bookingData.note_fuelReturnLevel)
          this.$set(this.bookingData, "note_fuelReturnLevel", 10);
      });
    },
    async getPrice() {
      await this.saveRoute(true)
      this.processDateRange();
      const pr = await api.fetchProcessor(
          "gears/cost_calculator",
          this.bookingData
      );
      _log_("wtf...", pr.data.results.cst);
      if (pr.data && pr.data.results) {
        if (pr.data.results.cst)
          this.$set(this.bookingData, "bookedPrice", pr.data.results.cst);
        // this.bookingData.bookedPrice = pr.data.results.cst;
        else
          this.$notify({
            title: "Warning",
            message: "Cant find price for this booking",
            type: "warning",
          });
      } else
        this.$notify({
          title: "Warning",
          message: "Something went wrong",
          type: "warning",
        });
    },
    checkAvailableVehicles(routes) {
      // const endMM = this.bookingData.bookingRange.end.getHours() * 60 + this.bookingData.bookingRange.end.getMinutes();
      // _log_("checkAvailableVehicles check...", endMM);
      if (!routes) return;
      let out = [],
          lkId = this.bookingData.asset_id,
          routename = this.bookingData.routeNum; //  this.selectedVehicle.id;

      routes.forEach((rt) => {
        // out.push({
        //   start: new Date(rt.in * 1000),
        //   end: new Date(rt.out * 1000),
        //   load: 100
        // });
        // _log_("checkAvailableVehicles RT check...", rt.endTimeMM % (24 * 60), endMM - rt.endTimeMM);
        if (rt.asset_id == lkId && (!routename || rt.routename != routename))
          for (
              let dayi = rt.startTimeMM;
              dayi <= rt.endTimeMM;
              dayi += 24 * 60
          ) {

            out.push({
              time: (rt.date + dayi * 60) * 1000,
              load: 99,
              startTimeHuman: rt.startTimeHuman,
              endTimeHuman: rt.endTimeHuman
            });
          }
      });
      out = out.sort((a, b) => a.time - b.time)
      if (out.length && this.bookingData.bookingRange?.start) {
        const lastUse = out[out.length - 1];
        const startEm = this.strTimeToInt(this.bookingData.finalPickupTime), //this.bookingData.bookingRange.start.getHours() * 60 + this.bookingData.bookingRange.start.getMinutes(),
            endAv = this.strTimeToInt(lastUse.endTimeHuman);
        _log_("checkAvailableVehicles ++ check...", this.bookingData.finalPickupTime, lastUse.endTimeHuman, startEm, endAv, ((startEm - endAv) / 60));
        if (((startEm - endAv) / 60) >= 0) lastUse.load = 40
      }
      // if (this.bookingData.bookingRange.end) {
      //   const endMM = this.bookingData.bookingRange.end.getHours() * 60 + this.bookingData.bookingRange.end.getMinutes(),
      //       lastAv = this.strTimeToInt(out[out.length - 1].startTimeHuman);
      //   // if()
      // }
      return out;
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    saveSignature(ctx) {
      if (!this.$refs.signaturePad) return;
      const {isEmptyObject, data} = this.$refs.signaturePad.saveSignature(
          "image/svg+xml"
      );

      _log_(isEmptyObject);
      this.bookingData["note_signature_" + ctx] = data;
      _log_(data);
    },
  },

  watch: {
    "bookingData.bookingRange": {
      handler(v, vo) {
        if (
            !this.bookingData.bookingRange ||
            !this.bookingData.bookingRange.end ||
            !this.bookingData.bookingRange.end
        )
          return;
        this.bookingSize =
            (this.bookingData.bookingRange.end.getTime() -
                this.bookingData.bookingRange.start.getTime()) /
            (1000 * 60 * 60);
      },
      deep: true,
    },
    async wtab(v, vo) {
      _log_("[wtab] init ", this.bookingData);
      if (!v || v == vo) return;
      if (v != "main" && !this.bookingData.id) {
        this.confirmSave = true;
      }
      if (v == "DELIVER") {
        this.goSign = !this.bookingData.note_signature_deliver;
        await this.loadImages("VEHICLE-DELIVER");
      }
      if (v == "RECEIVE") {
        this.goSign = !this.bookingData.note_signature_receive;
        await this.loadImages();
      }
      // if (v == "signature") this.goSign = !this.bookingData.note_signature;
    },
    "$route.query.rentState": {
      handler(v, vo) {
        if (v && v != vo) this.wtab = v == "pickup" ? "DELIVER" : "RECEIVE";
      },
      immediate: true,
    },
    "bookingData.asset_id"(v, vo) {
      if (v === vo) return
      this.fuels = {
        a: {load: null, time: this.unxnow(), comments: null, klmconusmed: null, status: 'checkin'},
        z: {load: null, time: this.unxnow() + 10, comments: null, klmconusmed: null, status: 'checkout'}
      }
    },
    "$route.params.transferBookingId": {
      async handler(bkid, oldbkid) {
        if (bkid == oldbkid) return
        if (bkid == 'copy' && this.$route.query.copy_id) {
          this.wtab = 'main'
          await this.loadRoute(this.$route.query.copy_id, true);
          this.resetFuels()
          this.$set(this.bookingData, "routeNum", null);
          this.$set(this.bookingData, "id", null);//customer_id
          this.$set(this.bookingData, "customer_id", null);//customer_id
          this.$notify({
            title: 'ΜεΓειά',
            message: 'Έχουμε αντίγραφο',
            type: 'success',

          });
          return
        }
        _log_("W $route.params.transferBookingId", bkid, this.bookingData.id, oldbkid);
        if (
            bkid &&
            bkid != "new" &&
            bkid != oldbkid &&
            (this.bookingData.id != bkid)
        ) {
          await this.loadRoute(bkid);
        }

        allVehicles = await this.getVehicles(
            this.$route.params.vehicleGroup
        );
        this.vehicles = [...allVehicles]
        if (bkid == "new") {
          // this.bookingData = null;

          if (this.$route.query.selected_asset)
            this.$set(
                this.bookingData,
                "asset_id",
                parseInt(this.$route.query.selected_asset)
            );
          // if (this.$route.query.initialTime) {

          //   // _log_("[cCAL] init?? ", csd, dd);
          // } else

          const csd =
              this.$route.query.initialTime &&
              this.$route.query.initialTime != "now"
                  ? parseInt(this.$route.query.initialTime)
                  : null;
          this.bookingData.bookingRange = {
            start: new Date(),
            end: new Date(),
          };

          this.setRange(null, 1);
          // this.bookingData = newbk;
          _log_("[cCAL] init ", this.bookingData.bookingRange);
          await this.prepareLoggedData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // bookingSize() {
    //   _log_("[cCAL] bookingSize ", this.bookingData.bookingRange);
    //   if (!this.bookingData.bookingRange) return 0;
    //   const mmm =
    //     (this.bookingData.bookingRange.end.getTime() -
    //       this.bookingData.bookingRange.start.getTime()) /
    //     (1000 * 60 * 60);
    //   return mmm;
    // },
    prUploadLisense() {
      return {
        ...this.uploadParams,
        context: "DR-LISENSE",
        refNum: this.bookingData.id,
      };
    },
    prUploadCar() {
      return {
        ...this.uploadParams,
        context: "VEHICLE-" + this.wtab,
        refNum: this.bookingData.id,
      };
    },
    userRelCoId() {
      return null;
      // return window.UserProfile ? window.UserProfile.userRelCoId : null;
    },
  },
};
</script>
<style scoped>
section.el-drawer__body {
  overflow: scroll;
}
</style>
